import { StandardEvents } from '@shopify/events';

class HunnaProductStock extends HTMLElement {
  #eventTarget;
  #request = 0;

  connectedCallback() {
    this.#eventTarget = this.closest('.shopify-section, dialog');
    this.#eventTarget?.addEventListener(StandardEvents.productSelect, this.#update);
  }

  disconnectedCallback() {
    this.#eventTarget?.removeEventListener(StandardEvents.productSelect, this.#update);
  }

  #update = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

    const request = ++this.#request;

    event.promise
      .then(({ detail }) => {
        if (request !== this.#request || !this.isConnected || !detail?.html) return;

        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;

        const replacement = detail.html.querySelector('hunna-product-stock');
        if (!replacement) return;

        this.innerHTML = replacement.innerHTML;
        this.dataset.productId = replacement.dataset.productId;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[hunna-product-stock] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('hunna-product-stock')) {
  customElements.define('hunna-product-stock', HunnaProductStock);
}
